"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PreferenceHttpAdapter = void 0;
const axios_1 = require("axios");
const http_error_exception_decorator_1 = require("../decorator/http-error-exception.decorator");
class PreferenceHttpAdapter {
    constructor(config, context) {
        this.config = config;
        if (config.loggerService) {
            this.log = config.loggerService.getLogger(context, {
                clientId: 'dp-user-preferences-sdk',
            });
        }
        else {
            this.log = console;
        }
        this.httpClient = axios_1.default.create(Object.assign(Object.assign({}, config.httpClientConfig), { baseURL: config.hostURL, transformRequest: [
                (data, headers) => {
                    var _a, _b;
                    if ((_b = (_a = this.config) === null || _a === void 0 ? void 0 : _a.user) === null || _b === void 0 ? void 0 : _b.token) {
                        headers.Cookie = `user=${this.config.user.token};active_role=${this.config.activeRole};greatminds.lti-bridge=${this.config.ltiBridge};`;
                    }
                    if (Array.isArray(data)) {
                        return JSON.stringify(data);
                    }
                    return data;
                },
            ] }));
    }
    setUser(user) {
        this.log.debug('Setting the user', user);
        this.config.user = user;
    }
    setActiveRole(ActiveRole) {
        this.log.debug('Setting the ActiveRole', ActiveRole);
        this.config.activeRole = ActiveRole;
    }
    setLtiBridge(ltiBridge) {
        this.log.debug('Setting the ltiBridge', ltiBridge);
        this.config.ltiBridge = ltiBridge;
    }
    getFeatureFlags(appName) {
        return __awaiter(this, void 0, void 0, function* () {
            this.log.debug('Getting the feature flag for', { appName });
            const requestResponse = yield this.httpClient.get(`/feature-flags/api/feature-flags/${appName}`);
            return requestResponse.data;
        });
    }
    getPreference(preferenceKey) {
        return __awaiter(this, void 0, void 0, function* () {
            this.log.debug('Getting the preference for', { preferenceKey });
            const requestResponse = yield this.httpClient.get(`/user-preferences/api/preferences/${preferenceKey}`);
            return requestResponse.data;
        });
    }
    setPreference(preferenceKey, preferenceValue) {
        return __awaiter(this, void 0, void 0, function* () {
            this.log.debug('Saving the preference for', { preferenceKey });
            const requestResponse = yield this.
                httpClient.post(`/user-preferences/api/preferences/${preferenceKey}`, preferenceValue, {
                headers: {
                    'Content-Type': 'application/json',
                },
            });
            this.log.info('Preference saved successfully');
            return requestResponse.data;
        });
    }
    getPreferences(prefix) {
        return __awaiter(this, void 0, void 0, function* () {
            this.log.debug('Getting all the preferences for', { prefix });
            const requestResponse = yield this.httpClient.get(`/user-preferences/api/preferences?prefix=${prefix}`);
            this.log.info('Fetched preferences for the user are:', requestResponse.data);
            return requestResponse.data;
        });
    }
}
__decorate([
    (0, http_error_exception_decorator_1.HandleHttpErrorException)(),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String]),
    __metadata("design:returntype", Promise)
], PreferenceHttpAdapter.prototype, "getFeatureFlags", null);
__decorate([
    (0, http_error_exception_decorator_1.HandleHttpErrorException)(),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String]),
    __metadata("design:returntype", Promise)
], PreferenceHttpAdapter.prototype, "getPreference", null);
__decorate([
    (0, http_error_exception_decorator_1.HandleHttpErrorException)(),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String, Array]),
    __metadata("design:returntype", Promise)
], PreferenceHttpAdapter.prototype, "setPreference", null);
__decorate([
    (0, http_error_exception_decorator_1.HandleHttpErrorException)(),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String]),
    __metadata("design:returntype", Promise)
], PreferenceHttpAdapter.prototype, "getPreferences", null);
exports.PreferenceHttpAdapter = PreferenceHttpAdapter;
//# sourceMappingURL=preference-http.adapter.js.map